import { GQL_ID } from '@@types'

import { useFavoriteProducts } from '@entities/Product'

export const useFavoriteCount = (shopId: GQL_ID) => {
  const { pageInfo } = useFavoriteProducts({
    shop_id: shopId,
    pager: {
      page: 1,
      limit: 1
    }
  })

  return pageInfo?.total ?? 0
}